import React from 'react';
import { Form, Input, Switch, Space } from 'antd';
import { MinusCircleOutlined } from '@ant-design/icons';
import { Delete03Icon } from '../../../components/icons';

const DrugFormItem = ({ name, restField, onRemove }) => {
  return (
    <Space
      style={{ display: 'flex', marginBottom: 8, alignItems: 'start', justifyContent: 'space-between' }}
      align="baseline"
    >
      <Form.Item
        {...restField}
        name={[name, 'name']}
        label="Drug Name"
        rules={[{ required: true, message: 'Missing drug name' }]}
        className="w-96"
      >
        <Input placeholder="Drug Name" className="w-full" />
      </Form.Item>
      <Delete03Icon onClick={onRemove} className="cursor-pointer h-4 w-4 text-red-500" />
    </Space>
  );
};

export default DrugFormItem;
